export default {"src":"/uk/_next/static/media/discoverIconYellow.7fd5e49c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};